import axios from 'axios';
import { QueryRequest, QueryResponse } from './types';

const API_BASE_URL = process.env.REACT_APP_API_URL || window.location.origin;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 120000, // 120 seconds timeout for long-running queries
});

export const queryProcedures = async (
  request: QueryRequest,
  signal?: AbortSignal
): Promise<QueryResponse> => {
  try {
    const response = await api.post<QueryResponse>('/query', request, { signal });
    return response.data;
  } catch (error) {
    // User pressed Stop (or the signal was aborted): rethrow a recognizable
    // AbortError so the caller can show a "cancelled" state, not an error.
    if (axios.isCancel(error)) {
      throw new DOMException('Request cancelled', 'AbortError');
    }
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.detail || 'Failed to query procedures');
    }
    throw error;
  }
};

export const healthCheck = async (): Promise<boolean> => {
  try {
    const response = await api.get('/health');
    return response.status === 200;
  } catch (error) {
    return false;
  }
};
